// src/reportWebVitals.ts
// web-vitals v4 API — Core Web Vitals: CLS, INP (FID yerine), LCP + FCP, TTFB.
// onPerfEntry verilmezse hiçbir şey ölçülmez (eski no-op davranışı korunur),
// ama index.tsx artık gerçek bir sink (sendWebVital) geçiriyor → RUM toplanır.
//
// ── NEDEN `web-vitals/attribution` (2026-08-19) ──────────────────────────
// Düz `web-vitals` girişi INP'nin DEĞERİNİ verir, SEBEBİNİ vermez: "INP 340 ms"
// bilinir ama hangi elemana dokunulduğu, gecikmenin hangi fazda (girdi
// gecikmesi / işleme / boyama) doğduğu ve hangi script'in blokladığı bilinmez.
// Teşhis körlüğü budur (yol haritası §2.13).
//
// `web-vitals/attribution` AYNI PAKETİN alt-yoludur (v4.2.4 zaten
// `package.json`'da) → YENİ BAĞIMLILIK YOK, yeni ağ isteği yok. API birebir
// aynı (`onCLS/onINP/onFCP/onLCP/onTTFB`); tek fark, metrik nesnesine bir
// `attribution` alanı eklenmesi. v4 bu alanda LoAF (Long Animation Frames)
// girdilerini de taşır — yani ayrı bir PerformanceObserver kurmaya gerek yok.
// Bedeli: bu chunk ~1–2 KB daha büyük (lazy `import()`, ilk boyamayı etkilemez).
//
// ⚠️ Aynı `onPerfEntry` sink'i tüm metrikler için kullanılır; attribution'ı
// GA4 alanlarına çeviren yer `services/webVitals.ts` (`sendWebVital`).

const reportWebVitals = (onPerfEntry?: (metric: any) => void) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import("web-vitals/attribution").then(({ onCLS, onINP, onFCP, onLCP, onTTFB }) => {
      onCLS(onPerfEntry);
      onINP(onPerfEntry); // FID kaldırıldı; INP yeni Core Web Vital.
      onFCP(onPerfEntry);
      onLCP(onPerfEntry);
      onTTFB(onPerfEntry);
    });
  }
};

export default reportWebVitals;
